import { SET_SEARCH_TEXT, CLEAR_SEARCH_TEXT } from "../actions";

export default function searchText(state = "", action) {
  switch (action.type) {
    case SET_SEARCH_TEXT:
      return action.payload;
    case CLEAR_SEARCH_TEXT:
      return "";
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/searchText.js